export function migrateTheme() {
  if (typeof window !== 'undefined') {
    const theme = localStorage.getItem('theme')

    const oldLightThemes = ['blue-light', 'rose-light', 'slate-light', 'green-light', 'orange-light']
    const oldDarkThemes = ['blue-dark', 'rose-dark', 'slate-dark', 'green-dark', 'orange-dark']

    if (theme && oldLightThemes.includes(theme)) {
      localStorage.setItem('theme', 'light')
    } else if (theme && oldDarkThemes.includes(theme)) {
      localStorage.setItem('theme', 'dark')
    }

    const themeConfig = localStorage.getItem('theme-config')
    if (themeConfig) {
      try {
        const config = JSON.parse(themeConfig)
        let updated = false

        if (config?.state?.config?.light && oldLightThemes.includes(config.state.config.light)) {
          config.state.config.light = 'light'
          updated = true
        }

        if (config?.state?.config?.dark && oldDarkThemes.includes(config.state.config.dark)) {
          config.state.config.dark = 'dark'
          updated = true
        }

        if (updated) {
          localStorage.setItem('theme-config', JSON.stringify(config))
        }
      } catch (e) {}
    }
  }
}
